import { CircleAlert } from "lucide-react";

import { Card, CardContent, CardHeader, CardTitle } from "../../components/ui/card";
import { formatDate } from "./formatters";

export default function NotificationsView({ notifications, onMarkAsRead }) {
  return (
    <Card className="support-content-card">
      <CardHeader>
        <CardTitle className="heading-2">Notifications</CardTitle>
      </CardHeader>
      <CardContent className="support-sidebar-content">
        {notifications.map((notification) => (
          <button
            type="button"
            key={notification.id}
            className={`support-notification-item ${notification.read ? "" : "is-unread"}`}
            onClick={() => onMarkAsRead(notification.id)}
          >
            <div className="support-notification-head">
              <strong>{notification.title}</strong>
              {!notification.read && <CircleAlert className="w-4 h-4" />}
            </div>
            <p>{notification.message}</p>
            <small>{formatDate(notification.created_at)}</small>
          </button>
        ))}
        {notifications.length === 0 && <p className="body-small">Aucune notification pour le moment.</p>}
      </CardContent>
    </Card>
  );
}
